import { put, takeEvery } from "redux-saga/effects"

// Calender Redux States
import * as constClass from "../../common/constant/constantURL"
import { SUBSCRIBED_EMAIL, UNSUBSCRIBED_EMAIL } from "./actionTypes"
import {
    getUnsubscribedFailed,
    getUnsubscribedSuccess
} from "./actions"

//Include Both Helper File with needed methods
import {
    postCall
} from "../../helpers/fakebackend_helper"

function* unsubscribedEmailHandler(data) {
    try {
        let url = constClass.REST_API_UNSUBSCRIBED_EMAIL
        const response = yield postCall(url, data.payload)
        yield put(getUnsubscribedSuccess(response))
    } catch (error) {
        yield put(getUnsubscribedFailed(error))
    }
}

function* subscribedEmailHandler(data) {
    try {
        let url = constClass.REST_API_SUBSCRIBED_EMAIL
        const response = yield postCall(url, data.payload)
        yield put(getUnsubscribedSuccess(response))
    } catch (error) {
        yield put(getUnsubscribedFailed(error))
    }
}

function* nonAuthenticatepagesSaga() {
    yield takeEvery(UNSUBSCRIBED_EMAIL, unsubscribedEmailHandler)
    yield takeEvery(SUBSCRIBED_EMAIL, subscribedEmailHandler)
}

export default nonAuthenticatepagesSaga
